import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './HeroSection';
import QuoteSection from './QuoteSection';
import IntroSection from './IntroSection';
import DesignSection from './DesignSection';
import PenghuSection from './PenghuSection';
import FutureSection from './FutureSection';
import SEO from '../../components/SEO';
import { useTranslation } from 'react-i18next';

export default function Home() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const title = isZh
    ? '國際扶輪和平意象｜澎湖和平意象紀念碑'
    : 'Rotary International Peace Monument | Penghu Peace Monument';
  const description = isZh
    ? '國際扶輪和平意象位於澎湖，是一座象徵和平、希望與國際交流的公共藝術作品。由台灣12個扶輪地區共同推動，獻給世界的和平祝福。讓和平從澎湖出發，讓世界看見台灣。'
    : 'The Rotary International Peace Monument in Penghu, Taiwan is a public artwork symbolizing peace, hope, and international exchange. Promoted by 12 Rotary districts across Taiwan, it is a blessing of peace from Taiwan to the world. Let Peace Begin from Penghu and Let the World See Taiwan.';
  const keywords = isZh
    ? '國際扶輪, 和平意象, 澎湖紀念碑, 公共藝術, 台灣地標, 和平鐘, 扶輪社'
    : 'Rotary International, Peace Monument, Penghu Landmark, Taiwan Public Art, Peace Bell, Rotary Club, Peace Memorial';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: title,
        url: `${siteUrl}/`,
        description,
        inLanguage: isZh ? 'zh-TW' : 'en',
        publisher: {
          '@type': 'Organization',
          name: isZh ? '國際扶輪' : 'Rotary International',
        },
      },
      {
        '@type': 'TouristAttraction',
        name: title,
        description,
        url: `${siteUrl}/`,
        isAccessibleForFree: true,
        address: {
          '@type': 'PostalAddress',
          addressLocality: isZh ? '澎湖' : 'Penghu',
          addressRegion: isZh ? '台灣' : 'Taiwan',
          addressCountry: 'TW',
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        canonical="/"
        schema={schema}
        lang={isZh ? 'zh-TW' : 'en'}
      />
      <Navbar />
      <main>
        <HeroSection />
        <QuoteSection />
        <IntroSection />
        <DesignSection />
        <PenghuSection />
        <FutureSection />
      </main>
      <Footer />
    </div>
  );
}